import { BaseForRestoreVMHelper } from 'wizards/helpers/bases/base-for-restore-vm-helper';
import { StepsDataFromPlanHelper } from 'wizards/helpers/steps-data-from-plan-helper/steps-data-from-plan-helper';

export class RestoreVMWareModelForStepsHelper extends BaseForRestoreVMHelper {
  protected static setSpecificStepsData(newPlan: unknown): void {
    this.restoreVMModel.selectHostStep = StepsDataFromPlanHelper.updateSelectHost(newPlan, !this.isCreate);
  }
}
